export enum FeatureFlagKeys {
  featurePushConsoleLogsToKibana = 'feature-push-console-logs-to-kibana',
  reconnectSoftphoneIfOutboundCallFails = 'reconnect-softphone-if-outbound-call-fails',
  featureInboxCallTransferToAgent = 'feature-inbox-call-transfer-to-agent',
  featureBillingReportDownload = 'feature-billing-report-download',
  featureWorkflowIvrMediaFileEnabled = 'feature-workflow-ivr-media-file-enabled',
  featureDisplayCampaignNameOnTaskAndToast = 'feature-display-campaign-name-on-task-and-toast',
  featureLogSoftphoneMfeConnectionInfo = 'feature-log-softphone-mfe-connection-info',
  featureLogSoftphoneConnectionInfoInterval = 'feature-log-softphone-connection-info-interval',
  // This flag is not in kebab-case due to inconsistency in LD flag naming conventions on the LD platform.
  // The flag is named "RTC-Webphone-EnableCallConnectionMonitoring" instead of "rtc-webphone-enable-call-connection-monitoring".
  // eslint-disable-next-line local-rules/require-kebab-case-feature-flags
  rtcWebphoneEnableCallConnectionMonitoring = 'RTC-Webphone-EnableCallConnectionMonitoring',
  featureRefreshUserStatus = 'feature-refresh-user-status',
  featurePreventMultipleRegistrations = 'feature-prevent-multiple-registrations',
  featureRtcWebphoneHandlesFetchingJwt = 'feature-rtc-webphone-handles-fetching-jwt',
  featureInboxCallWarmTransfers = 'feature-inbox-call-warm-transfers',
  featureRequireSeatAndBillToTenant = 'feature-require-seat-and-bill-to-tenant',
  featureVoicemailEmails = 'feature-voicemail-emails',
  featureAbandonedCallReportDownload = 'feature-abandoned-call-report-download',
  featureGracefullyHandleMicrophoneDisconnect = 'feature-gracefully-handle-microphone-disconnect',
  featureDataIntegrationEnabled = 'feature-data-integration-enabled',
  featureManagerAssist = 'feature-manager-assist',
  featureInboxIncomingTransferTag = 'feature-inbox-incoming-transfer-tag',
  featureLiveCallCenterMonitoringPage = 'feature-live-call-center-monitoring-page',
  featureOutboundMonitoringTab = 'feature-outbound-monitoring-tab',
  featureAgentDailyStatsUiEnabled = 'feature-agent-daily-stats-ui-enabled',
  featureShowDailyMetrics = 'feature-show-daily-metrics',
  fixDisablePopUpOnClose = 'fix-disable-pop-up-on-close',
  fixOutboundCallerIdErrors = 'fix-outbound-caller-id-errors',
  featureTransferInformationOnConversationHistory = 'feature-transfer-information-on-conversation-history',
  featureLinkCallInMonolithToCustomerAndLocationWhenCreatingNewCustomer = 'feature-link-call-in-monolith-to-customer-and-location-when-creating-new-customer',
  featureGlobalRecordingOverridesEnabled = 'feature-global-recording-overrides-enabled',
  featureMonitorAndResetUserStatus = 'feature-monitor-and-reset-user-status',
  featureNetworkMonitoringEnabled = 'feature-network-monitoring-enabled',
  featureLogUserStatusStuckInterval = 'feature-log-user-status-stuck-interval',
  featureAutoRefreshUserStatus = 'feature-auto-refresh-user-status',
  featureQueueRolloverTimeoutNotificationEnabled = 'feature-queue-rollover-timeout-notification-enabled',
  featureAbandonedCallFollowUps = 'feature-abandoned-call-follow-ups',
  featureSecondChanceLeadFollowUps = 'feature-second-chance-lead-follow-ups',
  featureVirtualAssistantFollowUps = 'feature-virtual-assistant-follow-ups',
  featureVoicemailFollowUps = 'feature-voicemail-follow-ups',
  featureManageAccounts = 'feature-manage-accounts',
  featureVirtualAgentConfiguration = 'feature-virtual-agent-configuration',
  featureRecordingDefaultsConfiguration = 'feature-recording-defaults-configuration',
  featureVirtualAssistantJobBooking = 'feature-virtual-assistant-job-booking',
  featureShowOpenCallsInConversationHistory = 'feature-show-open-calls-in-conversation-history',
  featureShowOutboundCallsRecordingInConversationHistory = 'feature-show-outbound-calls-recording-in-conversation-history',
  featureEnableDeleteQueue = 'feature-enable-delete-queue',
  featureHelpCenter = 'feature-help-center',
  featureSendReportToDebugService = 'feature-send-report-to-debug-service',
  featureBulkUserActions = 'feature-bulk-user-actions',
  featureOfflineOnClose = 'feature-offline-on-close',
  featureCallTimeoutWarning = 'feature-call-timeout-warning',
  featureInboxCallTransferToQueue = 'feature-inbox-call-transfer-to-queue',
  featureGraphqlSubscriptionsEnabled = 'feature-graphql-subscriptions-enabled',
  featureFilterVaInConversationHistory = 'feature-filter-va-in-conversation-history',
  featureShowCallHandlingEventsInConversationHistory = 'feature-show-call-handling-events-in-conversation-history',
  featureQueueManagementPage = 'feature-queue-management-page',
  featureCallContinuity = 'feature-call-continuity',
  featureCallContinuityBanner = 'feature-call-continuity-banner',
  featureSpeedToLeadOutboundingV0 = 'feature-speed-to-lead-outbounding-v-0',
  featureSpeedToLeadOutboundingAiTaskOutcome = 'feature-speed-to-lead-outbounding-ai-task-outcome',
  featureEnableSoftphoneMfeDebugging = 'feature-enable-softphone-mfe-debugging',
  featureSequentialEventProcessing = 'feature-sequential-event-processing',
  enableDebugLogsToKibana = 'enable-debug-logs-to-kibana',
  featureAddUsersToRecordingExclusions = 'feature-add-users-to-recording-exclusions',
  featureShowQueueLongestWaitTime = 'feature-show-queue-longest-wait-time',
  featureWebphoneServerConnectionMonitoring = 'feature-webphone-server-connection-monitoring',
  featureVaMfe = 'feature-va-mfe',
  featureVaDashboardMfe = 'feature-va-dashboard-mfe',
  featureCallTransferToTechnicians = 'feature-call-transfer-to-technicians',
  featureDisplayTechnicianConversationHistory = 'feature-display-technician-conversation-history',
  featureTransferOutboundToUserWithActivity = 'feature-transfer-outbound-to-user-with-activity',
  featureSpeedToLeadDemoCustomerPhoneNumber = 'feature-speed-to-lead-outbounding-v-0-demo',
  featureDisableSeatPromotion = 'feature-disable-seat-promotion',
  featureDisableQueueCreation = 'feature-disable-queue-creation',
  featureVoiceIntelligence = 'feature-voice-intelligence',
  featureQueueDrawerInfoPanel = 'feature-queue-drawer-info-panel',
  featureAudioDeviceManagement = 'feature-audio-device-management',
  featureCaptureFeUserActionEventsEnabled = 'feature-capture-fe-user-action-events-enabled',
  featureClientServerTimeDiffRefreshIntervalMinutes = 'feature-client-server-time-diff-refresh-interval-minutes',
  featureUserActionEventBatchIntervalSeconds = 'feature-user-action-event-batch-interval-seconds',
  featureChDefaultDateFilter = 'feature-ch-default-date-filter',
  featurePictureInPicture = 'feature-picture-in-picture',
  featureBlockBugReportsForUnsupportedLocales = 'feature-block-bug-reports-for-unsupported-locales',
  featureRtcsDegradedQueueDetection = 'feature-rtcs-degraded-queue-detection',
  featurePauseInteractionCountPollingWhenHidden = 'feature-pause-interaction-count-polling-when-hidden',
  featureConfigureOutboundSettings = 'feature-configure-outbound-settings',
  featureDeactivateWarmTransferInteraction = 'feature-deactivate-warm-transfer-interaction',
  featureMultiAgentSupportForVa = 'feature-multi-agent-support-for-va',
  featureMultiPathEscalations = 'feature-multi-path-escalations',
  featureReduceInteractionUpdateRequests = 'feature-reduce-interaction-update-requests',
  featureShowQueueWarningInTransfer = 'feature-show-queue-warning-in-transfer',
  featureQueueCallback = 'feature-queue-callback',
}

/**
 * A set of all valid FeatureFlagKeys in LD (in kebab-case, generally)
 */
const AllFeatureFlagKeys = new Set(Object.values(FeatureFlagKeys));

/**
 * Checks if a key is a valid FeatureFlagKeys.
 * @param key - the key to check
 * @returns true if the key is a valid, registered member of FeatureFlagKeys, false otherwise
 */
export const isValidFeatureFlagKey = (key: string): key is FeatureFlagKeys => {
  return AllFeatureFlagKeys.has(key as FeatureFlagKeys);
};
